// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor_VbJhK {
  height : 100%;
  width : 100%;
  border : 1px solid var( --lighter-grey );
}

.editorFlex_gAleA {
  height : 100%;
  width : 94%;
  margin-right: auto;
  margin-left: auto;
}
.editorFlex_gAleA  .header_yCY0M {
  width : 100%;
  color : var( --grey );
}
.editorFlex_gAleA .headerRow_f_ZaR {
  width: 100%;
}

.row_ULFQQ {
  width: 100%;
  display: flex;
}
.deployCode_gz7Am {
  margin-left: 8px;
}

.deployCode_gz7Am .text_staPg {
  margin-right: 5px;
}
.deployCode_gz7Am > * {
  color: var( --purple );
}

.themeDropdown_pJvnK {
  width: 150px;
  margin-right: 15px;
}

.pad_OuDt9 {
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/editors/script/style.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import \"../../style/theme.css\";\n\n.editor {\n  height : 100%;\n  width : 100%;\n  border : 1px solid var( --lighter-grey );\n}\n\n.editorFlex {\n  height : 100%;\n  width : 94%;\n  margin-right: auto;\n  margin-left: auto;\n}\n.editorFlex  .header {\n  width : 100%;\n  color : var( --grey );\n}\n.editorFlex .headerRow {\n  width: 100%;\n}\n\n.row {\n  width: 100%;\n  display: flex;\n}\n.deployCode {\n  margin-left: 8px;\n}\n\n.deployCode .text {\n  margin-right: 5px;\n}\n.deployCode > * {\n  color: var( --purple );\n}\n\n.themeDropdown {\n  width: 150px;\n  margin-right: 15px;\n}\n\n.pad {\n  padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `editor_VbJhK`,
	"editorFlex": `editorFlex_gAleA`,
	"header": `header_yCY0M`,
	"headerRow": `headerRow_f_ZaR`,
	"row": `row_ULFQQ`,
	"deployCode": `deployCode_gz7Am`,
	"text": `text_staPg`,
	"themeDropdown": `themeDropdown_pJvnK`,
	"pad": `pad_OuDt9`
};
export default ___CSS_LOADER_EXPORT___;
